<template>
  <div class="text-options-data-dialog">
    <div :class="filedMappingFieldValue ? 'mapping_content checked' : 'mapping_content'">
      <div class="verticallyBetweenCenter">
        <div class="content-title">
          {{ getValueByTypeHandle(options.innerElement) }}
        </div>
        <div class="verticallyCenter" v-if="options.innerElement == 'cxText' || options.innerElement == 'cxButton'">
          <el-checkbox v-model="isHyperlink">超链接</el-checkbox>
        </div>
      </div>
      <div class="select_content mt8">
        <el-select style="width: 100%" v-model="filedMappingFieldValue" placeholder="请选择" clearable>
          <el-option v-for="(item, index) in fieldMappingList" :key="index" :label="item.label" :value="item.value">
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mapping_date_content mt8" v-if="options.innerElement !== 'imageComponent'">
        <label class="date-label">显示为:</label>
        <el-dropdown trigger="click" @command="onChangeMappingType">
          <span class="el-dropdown-link">
            {{ fieldMappingDataType }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="custom-dropdown">
            <el-dropdown-item v-for="item in dataTypeList" :key="item.value" :command="item.value">
              <div :class="filedMappingDataType === item.value ? 'dropdown-item active' : 'dropdown-item'">
                {{ item.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="select_content mt8" v-if="isHyperlink">
        <el-select style="width: 100%" v-model="filedMappingLinkUrl" placeholder="请选择" clearable>
          <el-option v-for="(item, index) in fieldMappingList" :key="index" :label="item.label" :value="item.value">
            <span style="font-size: 13px">{{ item.label }}</span>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mt4" v-if="isHyperlink">
        <el-checkbox v-model="options.openBlankPage">新页面打开</el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { getValueByType, isExist } from "utils"
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentUpdateData.js"
import { UpdateData } from "utils/updateData/swiper/swiperComponentUpdateData.js"

export default {
  name: "filedMappingSetting",
  props: {
    myid: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      dataTypeList: [
        {
          label: "字段名称：字段内容",
          value: "dataKey"
        },
        {
          label: "字段内容",
          value: "dataValue"
        },
        {
          label: "字段名称",
          value: "dataName"
        }
      ],
      fieldMappingList: [
        {
          value: "src",
          label: "封面"
        },
        {
          value: "desc",
          label: "简介"
        }
      ], // 多图详情数据源
      detailFiledMappingValue: {}
    }
  },
  computed: {
    layoutOptions() {
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.myid, "rect")?.options
      if (
        rectAttr &&
        isExist(this.myid.elementInAutoLayoutId) &&
        (isExist(this.myid.elementInLayoutId) ||
          isExist(this.myid.elementInSwiperId) ||
          isExist(this.myid.elementInDataGridId)) &&
        rectAttr.innerElement === "cxAutoLayout"
      ) {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          ...this.myid,
          elementInLayoutId: undefined
        })
      }
      if (
        rectAttr &&
        rectAttr.pluginName &&
        (rectAttr.pluginName[0] == "loginLayoutComponent" || rectAttr.pluginName[0] === "loginEngineComponentPlugin")
      ) {
        return rectAttr
      }
      if (
        rectAttr &&
        rectAttr.innerElement !== "emptyLayoutComponent" &&
        rectAttr.innerElement !== "layoutComponent" &&
        rectAttr.innerElement !== "swiperComponent" &&
        rectAttr.innerElement !== "cxDataGrid"
      ) {
        return {}
      }
      return rectAttr
    },
    filedMapping() {
      if (!this.options.filedMapping) {
        this.$changeOptionsEV(
          { flag: true, dataType: "dataValue" },
          "filedMapping",
          false,
          null,
          {
            ...this.myid
          },
          true
        )
      }
      return this.options.filedMapping
    },
    filedMappingDataType: {
      get() {
        return this.filedMapping.dataType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping.dataType", false, null, {
          ...this.myid
        })
        this.updateData()
      }
    },
    filedMappingLinkUrl: {
      get() {
        return this.filedMapping.linkUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping.linkUrl", false, null, {
          ...this.myid
        })
      }
    },
    filedMappingFieldValue: {
      get() {
        return this.filedMapping.value
      },
      set(newVal) {
        if (!this.filedMapping.flag) {
          this.$changeOptionsEV(
            true,
            "filedMapping.flag",
            false,
            null,
            {
              ...this.myid
            },
            true
          )
          this.$changeOptionsEV(newVal, "filedMapping.value", false, null, {
            ...this.myid
          })
        } else {
          this.$changeOptionsEV(newVal, "filedMapping.value", false, null, {
            ...this.myid
          })
        }
        this.updateData()
      }
    },
    isHyperlink: {
      get() {
        return this.options.isHyperlink
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isHyperlink", false, null, {
          ...this.myid
        })
      }
    },
    fieldMappingDataType() {
      const item = this.dataTypeList.find(data => data.value === this.filedMappingDataType)
      return (item && item.label) || ""
    }
  },
  methods: {
    getValueByTypeHandle(type) {
      return getValueByType(type)
    },
    onChangeMappingType(value) {
      this.filedMappingDataType = value
    },
    async updateData() {
      let rectAttr = this.layoutOptions
      this.dataType = ""
      const dataPageIds = this.$store.state.states.getDataPageIds
      const { typeId, typeIds, relIds, isOr } = dataPageIds
      let { cacheDataTypes, restDataUrl, generalDataTypes } = {}
      let { activeIndex } = rectAttr
      if (rectAttr.innerElement === "swiperComponent") {
        const updateData = new UpdateData(this)
        const updateCb = (val, content_name, deep, deepName, ids) => {
          this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
        }
        const [drawLayoutAlready, completeData] = await updateData.upDateRect(
          rectAttr,
          this.cacheDataTypes,
          this.restDataUrl,
          this.myid,
          updateCb
        )
        this.drawData(drawLayoutAlready, completeData, updateData)
      } else {
        const updateLayoutData = new UpdateLayoutData(this)
        const { completeData, drawLayoutAlready } = await updateLayoutData.upDateRect({
          activeIndex,
          rectAttr,
          cacheDataTypes,
          renderModel: "data",
          wholeDataTypes: generalDataTypes,
          restDataUrl,
          typeId,
          typeIds,
          relIds,
          isOr,
          ids: {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
            path: this.layoutOptions.path
          },
          categoryMode: rectAttr?.options?.categoryMode || rectAttr?.categoryMode,
          addCb: param => {
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          },
          hideComponentCb: (param, opacity, display) => {
            if (!opacity && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          showComponentCb: (param, opacity, display) => {
            if (opacity === 0 && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "block"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          updateCb: (completeParam, opacity, display) => {
            let completeParamClone = Object.assign({}, completeParam)
            if (!opacity && !display) {
              // 把透明度重置为1
              completeParamClone.option_name = "opacity"
              completeParamClone.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
            }
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParam)
            completeParamClone.option_name = "display"
            const noEmpty = completeParam.option_val !== "" && isExist(completeParam.option_val)
            completeParamClone.option_val = noEmpty ? "block" : "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
          },
          delElementCb: (ids, opacity) => {
            let completeparam = Object.assign({}, ids)
            completeparam.option_name = "display"
            completeparam.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            if (!opacity) {
              // 把透明度重置为1
              completeparam.option_name = "opacity"
              completeparam.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            }
          },
          componentBoxUpdateCb: ({ url, dataId, uid, pageType }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: url,
              option_name: "componentBoxOptions-dataUrl"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)

            const dataIdParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: dataId,
              option_name: "componentBoxOptions-dataId"
            }

            const pageTypeParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: pageType,
              option_name: "componentBoxOptions-pageType"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", pageTypeParam)

            this.$store.dispatch(this.request_prefix + "/updateColsOption", dataIdParam)
          },
          componentBoxUpdateOpacity: ({ opacity, uid }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.layoutOptions.elementInAutoLayoutId,
              path: this.layoutOptions.path,
              uid: uid,
              option_val: opacity,
              option_name: "componentBoxOptions-opacity"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
          },
          updateEleCb: (val, content_name, deep, deepName, ids) => {
            this.$changeOptionsEV(val, content_name, deep, deepName, ids)
          }
        })
        this.startGetUserChoose(completeData, drawLayoutAlready, updateLayoutData)
      }
    },
    async startGetUserChoose(completeData, drawLayoutAlready, updateLayoutData) {
      const menus =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
          : this.$store.state.menu.menu.children[1].children
      updateLayoutData.startUpdateLayout(completeData, drawLayoutAlready, menus)
    },
    // 轮播根据数据绘制应用
    async drawData(drawLayoutAlready, completeData, updateData) {
      const createCb = param => {
        this.$store.dispatch(this.request_prefix + "/addComponentInSwiper", param)
      }
      const updateCb = (val, content_name, deep, deepName, ids) => {
        this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
      }
      const delSlideCb = param => {
        this.$store.dispatch(this.request_prefix + "/swiperContentControl", param)
      }
      //过滤掉数据中没用的数据和空数据，并给每个数组元素判断出需要增加的组件类型
      //轮播内组件数量和与后台数据一致性的校验
      if (drawLayoutAlready) {
        // 预先画好了布局,但没画完
        updateData.updateSwiperContent({ completeData, drawLayoutAlready, createCb, updateCb, delSlideCb })
      } else {
        updateData.updateSwiperContent({ completeData, createCb, updateCb, delSlideCb })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mapping_content {
  padding: 8px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  background-color: rgba(247, 248, 250, 1);
  &.checked,
  &:hover {
    border: 1px solid rgba(36, 0, 255, 0.16);
    background-color: rgba(36, 0, 255, 0.04);
  }
  .content-title {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
  .select_content {
    ::v-deep .el-input__inner {
      font-size: 13px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 0px 1px rgba(233, 233, 233, 1) inset;
    }
  }
  &.checked {
    .select_content {
      ::v-deep .el-input__inner {
        font-size: 13px;
        background-color: rgba(36, 0, 255, 0.1);
        color: rgba(36, 0, 255, 1);
        box-shadow: 0px 0px 0px 1px rgba(36, 0, 255, 0.16) inset;
        &:hover {
          background-color: rgba(36, 0, 255, 0.2);
        }
      }
      ::v-deep .el-select__caret {
        color: rgba(36, 0, 255, 1);
      }
      ::v-deep .is-focus .el-input__inner {
        background-color: rgba(36, 0, 255, 0.2);
      }
    }
  }
  .mapping_date_content {
    height: 20px;
    .date-label {
      font-size: 13px;
      color: var(--thirdTextColor);
      margin-right: 4px;
    }
    ::v-deep .el-dropdown {
      font-size: 13px;
    }
  }
  .el-checkbox {
    margin-right: 4px;
  }
  .verticallyBetweenCenter {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.text_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px;
  color: var(--elCollapseItemContentColor);
  &:not(:last-child) {
    margin-bottom: 8px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
  .el-checkbox {
    margin-right: 4px;
  }
  ::v-deep .el-input .el-input__inner {
    background-color: var(--leftMenuBgColor);
  }
}
.custom-dropdown {
  .dropdown-title-show {
    padding: 7px 12px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    ::v-deep .el-checkbox__label {
      font-size: 13px;
    }
  }
  ::v-deep .el-dropdown-menu__item {
    height: 34px;
    line-height: 34px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.8);
    .active {
      color: rgba(43, 103, 255, 1);
    }
  }
}
</style>
